import './research-output-ui-field-adapter-v401.js';
import './zooinvest-engine-core.js';
import './zooinvest-portfolio-engine.js';
import './zooinvest-market-engine.js';
import './zooinvest-tactical-market-engine.js';
import './zooinvest-ecosystem-engine.js';
import './zooinvest-decision-orchestrator.js';
import './zooinvest-evidence-ledger-engine.js';
import './zooinvest-calibration-engine.js';
import './zooinvest-metric-validation-engine.js';
import './zooinvest-business-durability-engine.js';
import './zooinvest-valuation-engine.js';
import './zooinvest-macro-event-engine.js';
import './zooinvest-rocket-engine.js';
import './zooinvest-economic-calendar-engine.js';
import './zooinvest-event-exposure-engine.js';
import './zooinvest-decision-sanity-engine.js';
import './zooinvest-hype-narrative-engine.js';
import './zooinvest-decision-challenge-engine.js';
import './zooinvest-pre-capital-checkpoint-engine.js';
import './zooinvest-contradiction-resolution-engine.js';
import './global-market-context-engine-v335.js';
import './market-decision-bridge-v336.js';
import './global-exposure-engine-v337.js';
import './portfolio-exposure-alert-engine-v338.js';
import './global-regime-change-engine-v339.js';
import './global-regime-cause-engine-v340.js';
import './cause-transmission-engine-v341.js';
import './what-matters-now-engine-v342.js';
import './research-queue-engine-v343.js';
import './evidence-gap-closure-engine-v344.js';
import './decision-readiness-gate-engine-v345.js';
import './executive-brief-engine-v346.js';
import './evidence-freshness-engine-v347.js';
import './research-completion-memory-engine-v348.js';
import './meaningful-change-detector-v349.js';
import './alert-suppression-engine-v350.js';
import './thesis-drift-engine-v351.js';
import './daily-attention-orchestrator-v352.js';
import './attention-delta-engine-v353.js';
import './review-cadence-engine-v354.js';
import './decision-audit-trail-engine-v355.js';
import './source-independence-guard-v356.js';
import './compound-signal-engine-v357.js';
import './compound-signal-delta-engine-v358.js';
import './evidence-cluster-engine-v359.js';
import './evidence-dependency-graph-engine-v360.js';
import './conclusion-invalidation-engine-v361.js';
import './research-state-snapshot-engine-v362.js';
import './daily-decision-brief-v2-v363.js';
import './research-priority-budget-engine-v364.js';
import './research-efficiency-engine-v365.js';
import './decision-change-priority-engine-v366.js';
import './dependency-aware-reopen-engine-v371.js';
import './evidence-lineage-engine-v372.js';
import './engine-contract-integration-guard-v373.js';
import './cross-engine-consistency-auditor-v374.js';
import './research-integrity-health-engine-v375.js';
import './research-integrity-decision-gate-v376.js';
import './daily-decision-brief-v3-integration-engine-v377.js';
import './research-state-persistence-adapter-v378.js';
import './research-state-repository-engine-v379.js';
import './supabase-repository-driver-contract-v380.js';
import './supabase-rls-ownership-contract-v381.js';
import './research-state-revision-concurrency-engine-v382.js';
import './research-state-bootstrap-orchestrator-v383.js';
import './research-state-event-journal-v384.js';
import './research-runtime-pipeline-orchestrator-v385.js';
import './research-failure-containment-engine-v386.js';
import './research-batch-orchestrator-v387.js';
import './runtime-capability-readiness-engine-v388.js';
import './runtime-session-coordinator-v389.js';
import './runtime-data-contract-gateway-v390.js';
import './runtime-provider-ingestion-bridge-v391.js';
import './sec-companyfacts-provider-adapter-v392.js';
import './alpha-vantage-daily-provider-adapter-v393.js';
import './provider-to-research-runtime-bridge-v394.js';
import './sec-canonical-financial-snapshot-v395.js';
import './sec-financial-health-input-bridge-v396.js';
import './sec-financial-history-engine-v397.js';
import './sec-growth-trajectory-input-bridge-v398.js';
import './company-research-data-package-v399.js';
import './company-package-research-pipeline-bridge-v400.js';
import './integration-contract-audit-v402.js';
import './research-pipeline-composition-root-v403.js';
import './end-to-end-research-runtime-v404.js';
import './market-daily-canonical-snapshot-v405.js';
import './end-to-end-market-context-integration-v405.js';
import './v406-runtime-ui-auto-bind.js';
import './persistent-runtime-session-composition-v407.js';
import './revision-aware-persistence-adapter-v408.js';
import './revision-aware-repository-v408.js';
import './revision-aware-runtime-session-v408.js';
import './coordinated-runtime-readiness-session-v409.js';
import {engineContext} from './context.js';
export const recoveredEngines=engineContext;
